export default __webpack_public_path__ + "static/media/ai_governance_compliance_score.36dcb217.svg";